// Whether WebGL is drawn by the CPU: no usable graphics card (virtual machines, blocked drivers, CI runners).
// Every off-screen render then costs seconds of main thread, so optional renders such as card photos are skipped.

const SOFTWARE = /swiftshader|llvmpipe|lavapipe|softpipe|software|basic render/i;

/** Renderer names of CPU implementations (Chrome's SwiftShader, Mesa's llvmpipe, Windows' Basic Render Driver). */
export const isSoftwareRenderer = (name: string | null | undefined): boolean => !!name && SOFTWARE.test(name);

let cached: boolean | undefined;

/** Probed once per page with a throwaway context, released right away (browsers cap live WebGL contexts). */
export function softwareRendering(): boolean {
  if (cached !== undefined) return cached;
  cached = false;
  try {
    const canvas = document.createElement('canvas');
    const gl = (canvas.getContext('webgl2') || canvas.getContext('webgl')) as WebGLRenderingContext | null;
    if (!gl) return (cached = true); // no WebGL at all: nothing optional to draw
    const info = gl.getExtension('WEBGL_debug_renderer_info');
    cached = isSoftwareRenderer(String(gl.getParameter(info ? info.UNMASKED_RENDERER_WEBGL : gl.RENDERER)));
    gl.getExtension('WEBGL_lose_context')?.loseContext();
  } catch {
    /* unknown: keep the full experience */
  }
  return cached;
}
